var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"boxTitle"},[_c('p',[_vm._v(_vm._s(_vm.TipsTitle))])]),_c('div',{staticClass:"boxContent",style:(_vm.Contentstyle)},[_c('pre',[_vm._v(_vm._s(_vm.TipsText))])]),_c('div',{staticClass:"boxBtn"},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.PopupTipsShowBtn}},[_vm._v("确定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }